import React from 'react';
import {Card, CardActions, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import Grid from "@mui/material/Grid";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import Button from "@mui/material/Button";
import {useFormContext} from "react-hook-form";
import clsx from "clsx";
import {relations} from "../../../../utils/dictionaries/Generics";
import {CustomAutoComplete} from "../../../widgets/inputs/CustomAutoComplete";

const AssociatoCard = ({name, rimuoviPaziente}) => {
	const classes = BaseStyle();
	const {control, errors} = useFormContext();
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{
				      height: "100%", display: "flex", flexDirection: "column", backgroundColor: "aliceblue"
			      }}>
				<CardHeader
					title={<Typography variant={"h6"} align={"center"}><b>Anagrafica paziente associato n°{name}</b></Typography>}
				/>
				<CardContent style={{flexGrow: 1}}>
					<Grid container spacing={3}>
						<AnagraficaCompleta classes={classes} intro={"--"} moreInfo={true} name={(name + ".")}/>
						<Grid item xs={12}>
							<CustomAutoComplete
								name={name + ".tipoRelazione"}
								label={"Tipo di relazione *"}
								control={control}
								options={Object.keys(relations).sort()}
								multiple={false}
								rules={{required: true}}
								error={errors[name]?.["tipoRelazione"]}
							/>
						</Grid>
					</Grid>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Inserisci un'anagrafica completa"}>
						<Button variant={"text"} disableElevation size="small" color="inherit"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={() => rimuoviPaziente(name)}>
							<b>Rimuovi</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(AssociatoCard);
